import { useTranslation } from "react-i18next";
import PageTitle from "../../layouts/PageTitle";
import { Col, Row } from "react-bootstrap";
import AppointmentHistory from "../../components/Custom/Appointment/AppointmentHistory";

const AppointmentList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('appointments')} motherMenu={t('appointments')} />
            <Row>
                <Col className="col-md-12">
                    <AppointmentHistory/>
                </Col>
            </Row>
        </>
    );
}

export default AppointmentList;